<template>
  <a-modal
    title="提现记录"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
  >
    <a-list
      class="demo-loadmore-list"
      :loading="loading"
      item-layout="horizontal"
      :data-source="list"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <a-tag slot="actions" :color="item.status | valInDict(tagColorDict)">{{ item.status | valInDict(statusDict) }}</a-tag>
        <a-list-item-meta :description="item.create_time">
          <div slot="title">{{ item.card_owner }}</div>
          <div slot="title">{{ item.bank }} {{ item.bank_branch }}</div>
          <div slot="title">{{ item.bank_card_number }}</div>
          <div v-if="item.remark" slot="title">{{ item.status==='REFUSE'?'拒绝理由':'备注' }}：{{ item.remark }}</div>
        </a-list-item-meta>
        <div>到账￥{{ item.arrival_money }}</div>
      </a-list-item>
    </a-list>
  </a-modal>
</template>

<script>
import { getWithdrawalPre, getWithdrawalList } from '@/api/withdrawal'

export default {
  data() {
    return {
      visible: false,
      statusDict: [],
      list: [],
      loading: true,
      tagColorDict: [
        { id: 'NORMAL', name: '#2db7f5' },
        { id: 'DONE', name: '#87d068' },
        { id: 'REFUSE', name: '#f50' }
      ]
    }
  },
  props: {},
  watch: {},
  methods: {
    // 显示
    showModal(orderType, orderId) {
      this.visible = true
      this.getPre()
      this.getList()
    },
    // 关闭
    handleCancel() {
      this.visible = false
      this.$emit('cancel')
    },
    // 预加载
    getPre() {
      getWithdrawalPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.statusDict = data.statusDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    // 获取列表
    getList() {
      this.loadingMore = true
      getWithdrawalList()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.list = data
            this.loading = false
          }
        })
        .catch((e) => {
          this.$message.error('获取提现记录失败')
        })
    }
  }
}
</script>
<style lang="less">

</style>
